export default __webpack_public_path__ + "static/media/newcars.1ff4e8e1.svg";